export default __webpack_public_path__ + "76ae3a9773cb347d7812521fdccadc2f.svg";